import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import YoybuySheetGuide from "@/pages/article/page";
import ShoesArticle from "@/pages/articles/ShoesArticle";
import HoodiesArticle from "@/pages/articles/HoodiesArticle";
import JacketsArticle from "@/pages/articles/JacketsArticle";
import BagsArticle from "@/pages/articles/BagsArticle";
import AccessoriesArticle from "@/pages/articles/AccessoriesArticle";
import SafetyArticle from "@/pages/articles/SafetyArticle";
import ShippingArticle from "@/pages/articles/ShippingArticle";
import VsAgentsArticle from "@/pages/articles/VsAgentsArticle";
import TaobaoArticle from "@/pages/articles/TaobaoArticle";
import SizesArticle from "@/pages/articles/SizesArticle";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/yoybuy-sheet-guide",
    element: <YoybuySheetGuide />,
  },
  {
    path: "/yoybuy-spreadsheet-shoes",
    element: <ShoesArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-hoodies",
    element: <HoodiesArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-jackets",
    element: <JacketsArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-bags",
    element: <BagsArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-accessories",
    element: <AccessoriesArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-safety",
    element: <SafetyArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-shipping",
    element: <ShippingArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-vs-agents",
    element: <VsAgentsArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-taobao",
    element: <TaobaoArticle />,
  },
  {
    path: "/yoybuy-spreadsheet-sizes",
    element: <SizesArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;